export class ShopProductPurchase extends HTMLElement {
    private labels: NodeListOf<HTMLLabelElement>
    private inputs: NodeListOf<HTMLInputElement>
    private sellingPlanInputs: HTMLInputElement

    // private sellingPlanInput: HTMLInputElement
    private sellingPlanLabel: HTMLLabelElement

    private labelOriginal: HTMLDivElement
    private labelSelected: HTMLDivElement

    constructor() {
        super()
        this.labels = this.querySelectorAll('[data-label]')
        this.inputs = this.querySelectorAll('input[name="purchase_option"]')
        this.sellingPlanInputs = document.querySelector('input[value="selling_plan"]')!

        // this.sellingPlanInput = this.querySelector('input[value="selling_plan"]')!
        this.sellingPlanLabel = this.querySelector('[data-label-selling-plan]')!

        this.labelOriginal = this.querySelector('[data-label-original]')!
        this.labelSelected = this.querySelector('[data-label-selected]')!

        console.log('sellingPlanLabel', this.sellingPlanLabel)

        if (this.sellingPlanLabel) {
            this.sellingPlanLabel.addEventListener('click', (evt) => {
                console.log('sellingPlanLabel clicked', evt)

                // Find the selling plan radio input and check it
                const sellingPlanInput = this.querySelector('input[value="selling_plan"]') as HTMLInputElement
                if (sellingPlanInput) {
                    sellingPlanInput.checked = true
                    // Trigger the change event to update the UI
                    sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }))
                }

                // Open the selling plan dropdown
                window.dispatchEvent(new CustomEvent('selling-plan:open', { detail: { open: true } }))
            })
        }

        ;(window as any).addEventListener('selling-plan:toggle', this.handleSellingPlanToggle.bind(this))
    }

    connectedCallback() {
        this.setupEventListeners()
    }

    private setupEventListeners() {
        this.inputs.forEach((input) => {
            input.addEventListener('change', (evt) => this.updateSelectionState(evt))
        })
    }

    private updateSelectionState(evt: Event) {
        console.log('updateSelectionState', evt)

        const isSellingPlan = (evt.target as HTMLInputElement).value === 'selling_plan'

        console.log('isSellingPlan', isSellingPlan)

        if (isSellingPlan) {
            window.dispatchEvent(new CustomEvent('selling-plan:open', { detail: { open: true } }))
        }

        this.inputs.forEach((input, index) => {
            const label = this.labels[index]

            console.log('label', label)

            if (label) {
                label.dataset.checked = input.checked.toString()

                console.log('label.dataset.checked', label.dataset.checked)

                if (input.checked) {
                    label.classList.add('bg-[#030303]')
                } else {
                    label.classList.remove('bg-[#030303]')
                }

                // Update aria attributes for accessibility
                label.setAttribute('data-checked', input.checked.toString())
            }
        })
    }

    private handleSellingPlanToggle(evt: CustomEvent) {
        const { isOriginal, name } = evt.detail

        console.log('handleSellingPlanToggle', evt)

        if (!isOriginal) {
            this.labelOriginal.classList.add('hidden')
            this.labelSelected.classList.remove('hidden')

            this.labelSelected.innerHTML = name
        } else {
            this.labelOriginal.classList.remove('hidden')
            this.labelSelected.classList.add('hidden')

            this.labelSelected.innerHTML = ''
        }
    }
}

customElements.define('shop-product-purchase', ShopProductPurchase)
